export default __webpack_public_path__ + "static/media/android-icon-192x192.e52e7ac3.png";